import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDataWrapper } from "../../../../lib/axios";

export const getLocations: any = createAsyncThunk(
  "settings/locations/list",
  async (params, thunkAPI) => {
    try {
      const response = await getDataWrapper("/location/getAllLocation");
      console.log(response);

      return response?.data;
    } catch (error: any) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const pickedOrder = createAsyncThunk(
  "settings/locations/add",
  async (params, thunkAPI) => {
    try {
      const response = await getDataWrapper("/add");
      return response?.data;
    } catch (error: any) {
      console.log(error);
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
